import { useState } from "react";
import { MessageCircle, PartyPopper, FileDown } from "lucide-react";
import { toast } from "sonner";
import { downloadFile, errMsg } from "../../lib/api";
import { Card, Btn } from "../kit";
import { waLink, waReceipt, waDone, DONE } from "../../lib/constants";

export function WhatsAppPanel({ o }) {
  const [busy, setBusy] = useState(false);
  const wa = o.customer.whatsapp;
  const open = (text) => window.open(waLink(wa, text), "_blank", "noopener");
  const pdf = async () => {
    setBusy(true);
    try { await downloadFile(`/orders/${o.id}/invoice.pdf`, `nota_${o.order_no}.pdf`); } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  const isDone = DONE.includes(o.status);
  return (
    <Card className="space-y-3" data-testid="whatsapp-panel">
      <h3 className="font-bold text-lg flex items-center gap-2"><MessageCircle className="w-5 h-5 text-emerald-600" /> Nota & WhatsApp</h3>
      {!wa && <div className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl p-3" data-testid="wa-missing">Pelanggan belum punya nomor WhatsApp. Edit order untuk menambahkan.</div>}
      <div className="grid grid-cols-1 gap-2">
        <Btn variant="success" disabled={!wa} onClick={() => open(waReceipt(o))} data-testid="wa-send-receipt-btn"><MessageCircle className="w-5 h-5" /> Kirim Nota via WA</Btn>
        <Btn variant={isDone ? "primary" : "secondary"} disabled={!wa} onClick={() => open(waDone(o))} data-testid="wa-send-done-btn"><PartyPopper className="w-5 h-5" /> Kirim "Pesanan Selesai"</Btn>
        <Btn variant="secondary" loading={busy} onClick={pdf} data-testid="invoice-pdf-btn"><FileDown className="w-5 h-5" /> Unduh Nota PDF</Btn>
      </div>
      {!isDone && <p className="text-xs text-slate-500">Pesan "Pesanan Selesai" sebaiknya dikirim setelah status order Selesai.</p>}
    </Card>
  );
}
